import { forwardRef, isValidElement, cloneElement } from 'react';
import mergeRefs from 'react-merge-refs';
import { animated } from 'react-spring';
import { merge } from 'lodash'; // Doing this stops us from having to use a wrapping div to animate
// and instead we can pass the styles directly to the underlying DOM
// This assumes that if the children of this component are themselves
// react components, that they are forwarding their ref
// down to the DOM element that should be animated

export var Animated = animated( /*#__PURE__*/forwardRef(function AnimatedComponent(_ref, ref) {
  var children = _ref.children;

  if ( /*#__PURE__*/isValidElement(children)) {
    return /*#__PURE__*/cloneElement(children, merge({}, {
      style: children.props.style
    }, {
      // @ts-ignore
      ref: mergeRefs([ref, children.ref])
    }));
  }

  return null;
}));